var CRcarrierServiceEnabled = true;

const pickupLocations = [
  {
    name: "ADELAIDE",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "ANTWERP",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "ATHENS",
    service: "Pickup and Delivery",
    pickupAddress: "The pick address is near Vourvachi Street, Athens. Your order confirmation email will include the complete address."
  },
  {
    name: "AUCKLAND",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "BEIJING",
    service: "Pickup Only",
    pickupAddress: "The pick up address is in the Chaowai neigborhood, Beijing Your order confirmation email will include the complete address."
  },
  {
    name: "BELLAGIO",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "BRISBANE",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up location is in the north suburb of Aspley 4034. Your order confirmation email will include the complete address. BTW, we offer free delivery to most locations in inner city Brisbane."
  },
  {
    name: "BRUSSELS",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "CAIRNS",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up location is in conveniently located central in central Cairns. Your order confirmation email will include the complete address."
  },
  {
    name: "CANBERRA",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "GENEVA",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up location is in conveniently located in central Geneva. Your order confirmation email will include the complete address."
  },
  {
    name: "GHENT",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "GOLD COAST",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "HOBART",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up location is in conveniently located in central Hobart. Your order confirmation email will include the complete address."
  },
  {
    name: "LAKE COMO",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up location is in conveniently located in the township of Como. Your order confirmation email will include the complete address."
  },
  {
    name: "LEUVEN",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "LONDON",
    service: "Pickup Only",
    pickupAddress: "The pick up location is near Richmond Park, a great location to start your ride. Your order confirmation email will include the complete address."
  },
  {
    name: "LONG BEACH",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "LOS ANGELES",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "MELBOURNE",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up location is in conveniently located in Fitzroy, 1km north of the Melbourne CBD. Your order confirmation email will include the complete address."
  },
  {
    name: "MILAN",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "NEW YORK",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "NEWCASTLE",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up location is in conveniently located in central Newcastle. Your order confirmation email will include the complete address."
  },
  {
    name: "NOOSA",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "ORANGE COUNTY",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "PALO ALTO",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "PASADENA",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "PERTH",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up location is in conveniently located in the Perth CBD. Your order confirmation email will include the complete address.  BTW, we offer free delivery to most locatons Newcastle."
  },
  {
    name: "PORT DOUGLAS",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up location is in conveniently located in central Cairns. Your order confirmation email will include the complete address. It is easy to collect your bike on you way to Port Douglas."
  },
  {
    name: "SAN DIEGO",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "SAN FRANCISCO",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "SAN JOSE",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "SAN MATEO",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "SANTA BARBARA",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "SANTA MONICA",
    service: "Delivery Only",
    pickupAddress: ""
  },
  {
    name: "SINGAPORE",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up address is in the HortPark neighborhood of Singapore. Your order confirmation email will include the complete address."
  },
  {
    name: "SYDNEY",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up address is in the suburb of Matraville. Your order confirmation email will include the complete address. BTW, we offer free delivery to the Sydney CBD."
  },
  {
    name: "TOKYO",
    service: "Pickup and Delivery",
    pickupAddress: "The pick up location is in Buguggiate. Your order confirmation email will include the complete address."
  },
  {
    name: "VARESE",
    service: "Pickup and Delivery",
    pickupAddress: ""
  },
  {
    name: "ZURICH",
    service: "Delivery Only",
    pickupAddress: ""
  }
];

var mandatoryPickup = false;
var mandatoryForDelivery = false;
var specialProduct3 = false;

const mandatoryForPickupLocations = ['LONDON', 'BEIJING']; 
const mandatoryForDeliveryLocations = [
  /*'ADELAIDE', 'ANTWERP', 'AUCKLAND', 'BELLAGIO','BRUSSELS', 'CANBERRA', 'GHENT', 'GOLD COAST', 'LEUVEN', 'LONG BEACH', 'LOS ANGELES', 'MILAN', 'NEW YORK',
                                      'NOOSA', 'ORANGE COUNTRY', 'PALO ALTO', 'PASADENA', 'SAN DIEGO', 'SAN FRANCISCO', 'SAN JOSE', 
                                       'SAN MATEO', 'SANTA BARBARA', 'SANTA MONICA', 'ZURICH',*/
'Adelaide Road Bike Rental',
'Antwerp Road Bike Rental',
'Auckland Road Bike Rental',
'Bellagio Road Bike Rental',
'Brussels Road Bike Rental',
'Canberra Road Bike Rental',
'Ghent Road Bike Rental',
'Gold Coast Road Bike Rental',
'Leuven Road Bike Rental',
'Long Beach Road Bike Rental',
'Los Angeles Road Bike Rental',
'Milan Road Bike Rental',
'New York Road Bike Rental',
'Noosa Road Bike Rental',
'Orange County Road Bike Rental',
'Palo Alto Road Bike Rental',
'Pasadena Road Bike Rental',
'San Diego Road Bike Rental',
'San Francisco Road Bike Rental',
'San Jose Road Bike Rental',
'San Mateo Road Bike Rental',
'Santa Barbara Road Bike Rental',
'Santa Monica Road Bike Rental',
'Zurich Road Bike Rental',
]; 

let addressToShow = '';

for (var i = 0; i < crItems.length; i++ ){
  var itemCollections = crItems[i].collections
  var itemTitle = crItems[i].name;
  if (itemTitle === 'Pickup Instore') continue;
  //console.log({itemTitle})  
  console.log('-->', itemCollections)

  if (mandatoryForPickupLocations.some(keyword => itemCollections.toLowerCase().includes(keyword.toLowerCase()))) {
    mandatoryPickup = true;
  }

  if (mandatoryForDeliveryLocations.some(keyword => itemCollections.toLowerCase().includes(keyword.toLowerCase()))) {
    mandatoryForDelivery = true;
  } 

  const matchingLocations = pickupLocations.filter(location =>
    //location.name.toLowerCase().includes(itemCollections.toLowerCase())
    itemCollections.toLowerCase().includes(location.name.toLowerCase())
  );
  //console.log(matchingLocations)
  for (const matchingLocation of matchingLocations) {
    //console.log('--->', matchingLocation.pickupAddress);
    addressToShow += matchingLocation.pickupAddress;
  }
  
}

document.addEventListener('crJQActivated', function (e) {
  console.log('* Mandatory for pickup *')
  if (mandatoryPickup === true) {
    jqCR('.cr-shipping-method').hide(function(){    
      jqCR('.pickup-button').click()  
    });    
  }

  if (mandatoryForDelivery === true) {
    jqCR('.pickup-button').hide();    
  }
})

document.addEventListener('crPickupActivated', function (e) {
  $('.delivery-method-desc').after(`<div class="cr-pickup-address-v2">${ addressToShow }</div>`);
  $('body').on('click', '.cr-delivery-method', function(){
    $('.cr-pickup-address-v2').remove()
    location.reload();
  })
})
